import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { NavigationStoreSelectorLink } from "./NavigationStoreSelectorLink";
import "./NavigationStoreSelector.scss";
export const NavigationStoreSelector = ({ list }) => {
    const rootClassName = "aem-navigationStoreSelector";
    return (_jsx("div", { className: classNames(rootClassName), "data-testid": "navigation-store-selector", children: _jsx("ul", { className: classNames(`${rootClassName}__links-container`), children: list?.map(({ title, path, relatedLanguage }) => (_jsx(NavigationStoreSelectorLink, { title: title, path: path, relatedLanguage: relatedLanguage }, title))) }) }));
};
//# sourceMappingURL=NavigationStoreSelector.js.map